
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import useLatest from '../useLatest/index.js';
import { getTargetElement } from '../utils/domTarget.js';
import getDocumentOrShadow from '../utils/getDocumentOrShadow.js';
import useEffectWithTarget from '../utils/useEffectWithTarget.js';

function useClickAway(onClickAway, target, eventName) {
  if (eventName === void 0) {
    eventName = 'click';
  }
  var onClickAwayRef = useLatest(onClickAway);
  useEffectWithTarget(function () {
    var handler = function (event) {
      var targets = Array.isArray(target) ? target : [target];
      if (targets.some(function (item) {
        var targetElement = getTargetElement(item);
        return !targetElement || targetElement.contains(event.target);
      })) {
        return;
      }
      onClickAwayRef.current(event);
    };
    var documentOrShadow = getDocumentOrShadow(target);
    var eventNames = Array.isArray(eventName) ? eventName : [eventName];
    eventNames.forEach(function (event) {
      return documentOrShadow.addEventListener(event, handler);
    });
    return function () {
      eventNames.forEach(function (event) {
        return documentOrShadow.removeEventListener(event, handler);
      });
    };
  }, Array.isArray(eventName) ? eventName : [eventName], target);
}

export { useClickAway as default };
//# sourceMappingURL=index.js.map
